'use client';

import React from 'react';

interface ClientOnClickProps {
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLElement>;
}

export default function ClientOnClick({ children, onClick }: ClientOnClickProps) {
  return (
    <div onClick={onClick}>
      {children}
    </div>
  );
}